import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../api/agent";
import { AppFilter } from "../../../../models/app/AppModels";

export const quotationApi = createApi({
  reducerPath: "quotationApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    getQuotations: build.query<any, { paging: AppFilter }>({
      query: ({ paging }) => ({
        url: `api/CustomerQuotation/GetQuotations`,
        method: "post",
        data: paging,
      }),
    }),
    markQuotesAsRead: build.mutation<any, void>({
      query: () => ({
        url: `api/CustomerQuotation/MarkQuotesAsRead`,
        method: "put",
        data: null,
      }),
    }),
  }),
});

export const { useGetQuotationsQuery, useMarkQuotesAsReadMutation } =
  quotationApi;
export const quotationReducer = quotationApi.reducer;
